import React from 'react'
import gifweb1 from '../assets/imgs/Framergif.gif'

export const GifwebOne = () => {
  return (
    <div>
        <img src={gifweb1} alt="gifweb" className="w-full h-full m-3 rounded-md" />
    </div>
  )
}